import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import '../../styles/textStyle.css';
import '../hooks/useAutofillEvent.css';
import './BaseInput.css';
export var container = '_1a8lqy98-3-15-1';
export var containerPadding = {none:'_1a8lqy99-3-15-1',rightNone:'_1a8lqy9a-3-15-1',rightUnset:'_1a8lqy9b-3-15-1',leftUnset:'_1a8lqy9c-3-15-1'};
export var disabled = '_1a8lqy92-3-15-1';
export var divider = '_1a8lqy9f-3-15-1';
export var hasError = '_1a8lqy91-3-15-1';
export var input = '_1a8lqy9d-3-15-1 _yfwka33-3-15-1 _da9a8v0-3-15-1 _da9a8v2-3-15-1 _da9a8v3-3-15-1 _da9a8vb-3-15-1';
export var isAutoFilled = '_1a8lqy9g-3-15-1';
export var readOnly = '_1a8lqy93-3-15-1';
export var reservedSuffixButton = '_1a8lqy9e-3-15-1';
export var variant = {'default':'_1a8lqy94-3-15-1',minimal:'_1a8lqy95-3-15-1'};
export var wrapper = '_1a8lqy90-3-15-1';